module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Weight#2-f6c4602cb0d7f95963f5af56ebc61722abd7bda791c237007a4e4591b7a1ef75.svg";